import { render, staticRenderFns } from "./Something.vue?vue&type=template&id=1cc9f23a&"
import script from "./Something.vue?vue&type=script&lang=js&"
export * from "./Something.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports